
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.125 4.865A2.408 2.408 0 017.57 3.004a2.358 2.358 0 012.484 2.208c0 1.66-2.374 2.208-2.374 3.313M7.68 11.096c.077 0 .139.062.139.138","stroke":"#D07D01","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.51 1.34A6.986 6.986 0 00.626 7c0 .92.177 1.799.5 2.604a7.016 7.016 0 002.123 2.857m8.668-10.99A6.984 6.984 0 0114.625 7a6.987 6.987 0 01-2.783 5.586","stroke":"#D07D01","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    